<template>
  <v-layout align-start class="my-4">
    <v-layout column class="subheading" style="width: 650px">
      <v-layout class="mx-2 my-1">
        <v-flex xs4>Name: </v-flex>
        <v-flex xs6 data-testid="contact-name">
          {{ selectedContact.customer_first_name }} {{ selectedContact.customer_last_name }}
        </v-flex>
      </v-layout>
      <v-layout class="mx-2 my-1">
        <v-flex xs4>Phone Number: </v-flex>
        <v-flex xs6 data-testid="contact-phone">{{
          addDashes(selectedContact.customer_phone)
        }}</v-flex>
      </v-layout>
      <v-layout class="mx-2 my-1">
        <v-flex xs4>Email: </v-flex>
        <v-flex xs6 data-testid="contact-email">{{
          selectedContact.customer_email
        }}</v-flex>
      </v-layout>
      <v-layout class="mx-2 my-1">
        <v-flex xs4>Reserved On: </v-flex>
        <v-flex xs6 data-testid="contact-reserved-on">{{
          timestamp(selectedContact.placed_at)
        }}</v-flex>
      </v-layout>
      <v-layout class="subheading mx-2 my-1">
        <v-flex xs4>Move-in Date: </v-flex>
        <v-flex xs6 data-testid="contact-move-in">{{
          formatDateUTC(selectedContact.move_in_date)
        }}</v-flex>
      </v-layout>
      <v-layout class="mx-2 my-1">
        <v-flex xs4>Follow-up Date: </v-flex>
        <v-flex xs6 data-testid="contact-follow-up">{{
          formatDate(selectedContact.followup_at)
        }}</v-flex>
      </v-layout>
      <v-layout class="mx-2 my-1">
        <v-flex xs4>Source:</v-flex>
        <v-flex xs6 data-testid="contact-source">{{
          selectedContact.customer_source
        }}</v-flex>
      </v-layout>
      <v-layout class="mx-2 my-1">
        <v-flex xs4>Reservation Type:</v-flex>
        <v-flex xs6 data-testid="contact-reservation-type">
          <span v-if="selectedContact.type == 1">Lead</span>
          <span v-else>Reservation</span>
        </v-flex>
      </v-layout>
      <v-form ref="form" class="mt-4 ml-1" style="width: 515px">
        <app-input
          data-testid="follow-up-call-id-input"
          class="follow-up-call-id-input"
          v-model="ctmId"
          :type="'number'"
          label="Call ID"
          placeholder="Enter Call ID..."
          outlined
          :rules="{ required: true }"
        ></app-input>
      </v-form>
      <v-layout class="ml-1">
        <transition name="slide-x-transition" mode="out-in">
          <v-flex v-if="!emailFollowUpInput" key="button">
            <v-btn
              data-testid="open-express-checkin-btn"
              class="open-express-checkin-btn white--text ml-0"
              color="teal lighten-1"
              :elevation="22"
              large
              raised
              @click="displayEmailFollowUpInput"
            >
              Email Express Check-In
            </v-btn>
          </v-flex>
          <v-layout v-else key="input" style="height: 55px">
            <v-flex xs9>
              <v-form ref="lead-form">
                <app-input
                  data-testid="follow-up-customer-email-input"
                  class="follow-up-customer-email-input"
                  v-model="customerEmail"
                  :type="'email'"
                  label="Email"
                  placeholder="Enter Customer's Email..."
                  outlined
                  :rules="{ required: true, email: true }"
                ></app-input>
              </v-form>
            </v-flex>
            <v-flex xs1 class="mr-2 mt-2 pt-1">
              <v-btn
                color="teal lighten-1"
                data-testid="send-express-checkin-btn"
                class="send-express-checkin-btn"
                fab
                bottom
                :loading="emailLoading"
                :disabled="!validEmail"
                @click="handleExpressCheckInEmail"
              >
                <v-icon>mail_outline</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs1 class="mt-2 pt-1">
              <v-btn
                data-testid="close-email-btn"
                class="close-email-btn"
                color="red darken-2"
                fab
                bottom
                @click="emailFollowUpInput = false"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </transition>
      </v-layout>
    </v-layout>
    <v-layout column class="subheading" style="width: 500px">
      <v-layout class="mx-2 my-1">
        <v-flex xs4>Unit Name: </v-flex>
        <v-flex xs6 data-testid="contact-unit-name">{{
          unitFeatures.type_name
        }}</v-flex>
      </v-layout>
      <v-layout class="mx-2 my-1">
        <v-flex xs4>Unit Type: </v-flex>
        <v-flex xs6 data-testid="contact-unit-type">{{
          unitFeatures.product_type
        }}</v-flex>
      </v-layout>
      <v-layout class="mx-2 my-1">
        <v-flex xs4>Unit Size: </v-flex>
        <v-flex xs6 data-testid="contact-unit-size">
          <span v-if="unitFeatures.width">
            {{ parseFloat(unitFeatures.width) }}' x {{ parseFloat(unitFeatures.length) }}'
          </span>
          <span v-else>'{{ parseFloat(unitFeatures.length) }}</span>
        </v-flex>
      </v-layout>
      <v-layout class="mx-2 my-1">
        <v-flex xs4>Quoted Price: </v-flex>
        <v-flex xs6 data-testid="contact-quoted-price">
          ${{ parseFloat(selectedContact.quoted_price).toFixed(2) }}/month
        </v-flex>
      </v-layout>
      <v-layout class="mx-2 my-1" v-if="promotionOffers">
        <v-flex xs4>Promotion Offered: </v-flex>
        <v-flex xs6 data-testid="contact-promotion-offered">{{
          promotionOffers.this_month.text
        }}</v-flex>
      </v-layout>
      <v-layout class="mx-2 my-1">
        <v-flex xs4>Unit Features: </v-flex>
        <v-layout column data-testid="contact-unit-features">
          <v-flex v-for="(feature, i) of unitFeatures.features" :key="i" xs6>
            {{ feature }}
          </v-flex>
        </v-layout>
      </v-layout>
      <v-layout class="mx-2 my-1">
        <v-flex xs4>Facility: </v-flex>
        <v-flex xs6 data-testid="contact-facility-name">{{
          facilityInfo.name
        }}</v-flex>
      </v-layout>
      <v-layout class="mx-2 my-1">
        <v-flex xs4>Location Code: </v-flex>
        <v-flex xs6 data-testid="contact-location-code">{{
          facilityInfo.location_code
        }}</v-flex>
      </v-layout>
      <v-layout class="mx-2 my-1">
        <v-flex xs4>Phone: </v-flex>
        <v-flex xs6 data-testid="contact-facility-phone">{{
          addDashes(facilityInfo.phone)
        }}</v-flex>
      </v-layout>
      <v-layout class="mx-2 my-1">
        <v-flex xs4>Address: </v-flex>
        <v-flex xs6 data-testid="contact-facility-address-1">{{
          facilityInfo.street_address
        }}</v-flex>
      </v-layout>
      <v-layout class="mx-2 my-1">
        <v-flex xs4></v-flex>
        <v-flex data-testid="contact-facility-address-2">
          {{ facilityInfo.city }}, {{ facilityInfo.state }} {{ facilityInfo.postal_code }}
        </v-flex>
      </v-layout>
    </v-layout>
  </v-layout>
</template>

<script>
import { emailRules, inputRules } from "@/helpers/form-rules";
import { dateMethodMixins } from "@/mixins/dateMethodMixins";
import moment from "moment";

export default {
  name: "FollowUpDetails",
  props: {
    callId: {
      type: String,
      default: ""
    },
    facilityInfo: {
      type: [Object, String],
      default: ""
    },
    promotionOffers: {
      type: [Object, String],
      default: ""
    },
    selectedContact: {
      type: [Object, null],
      default: null
    },
    unitFeatures: {
      type: [Object, null],
      default: null
    }
  },
  mixins: [dateMethodMixins],

  data() {
    return {
      customerEmail: "",
      emailFollowUpInput: false,
      emailLoading: false,
      emailRules: emailRules,
      inputRules: inputRules
    };
  },

  methods: {
    displayEmailFollowUpInput() {
      this.emailFollowUpInput = true;
      this.customerEmail = this.selectedContact.customer_email;
    },

    handleExpressCheckInEmail() {
      this.emailLoading = true;
      let payload = {
        external_id: this.selectedContact.waiting_list_id,
        facility_id: this.selectedContact.facility_id,
        email_address: this.customerEmail
      };

      this.$store
        .dispatch("sendExpressCheckInEmail", payload)
        .then(() => {
          this.emailLoading = false;
          this.$store.dispatch("handleSuccess", "Email sent!");
          this.emailFollowUpInput = false;
        })
        .catch((err) => {
          this.emailLoading = false;
          this.$store.dispatch("handleError", err);
          this.emailFollowUpInput = false;
        });
    },

    addDashes(phone) {
      if (phone) {
        if (phone.length === 10 && typeof phone.replace === "function") {
          return phone.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
        } else {
          return phone;
        }
      }
    },

    timestamp(date) {
      return moment(date).format("MM/DD/YYYY, h:mm a");
    }
  },

  computed: {
    ctmId: {
      get() {
        return this.callId;
      },
      set(newVal) {
        this.$emit("input", newVal);
      }
    },

    validEmail() {
      let regex = /^\S+@\S+\.\S+$/;
      return regex.test(this.customerEmail);
    }
  }
};
</script>
